<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{title}}</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">上传提示：</div>
                <div class="right">
                    <p>1.本功能主要用于上传一些需要存放在网站根目录下的校验文件</p>
                    <p>2.上传时请备注文件的用途</p>
                    <p>3.可上传.txt 和.html 格式的文件，1M以内。请勿上传其它文件</p>
                </div>
            </div>
            <el-form class="form-container" :model="info" :rules="siteFileRules" ref="addsiteFileForm">
                 <div class="form-item"  v-if="this.fileId">
                    <div class="form-label">
                        <span class="label">选择文件</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item" >
                         <el-form-item >
                            <div>{{info.name}}</div>
                        </el-form-item>    
                    </div>
                </div>
                <div class="form-item" style="height: 152px" v-else>
                    <div class="form-label">
                        <span class="label">选择文件</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="path">
                        <div class="huxing-input">
                            <div
                            class="upload-group clearfix"
                            v-if="info.path && info.path !== ''"
                            >
                            <div class="upload-item">
                                <img :src="excelUrl" alt />
                                <div class="shadow">
                                <i class="el-icon-delete" @click="clearUploadZt"></i>
                                </div>
                            </div>
                            </div>
                            <div class="upload-group-2" v-else>
                            <i class="el-icon-plus"></i>
                            <input
                                type="file"
                                class="type-file"
                                accept="zip"
                                @change="checkZtFile($event)"
                                id="pictureUploadZt"
                            />
                            </div>
                        </div>
                        </el-form-item>
                        
                    </div>
                </div>
                 <div class="form-item">
                    <div class="form-label">
                        <span class="label">备注</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="remark">
                            <el-input type="textarea" v-model="info.remark" placeholder="请备注文件用途"></el-input>
                        </el-form-item>
                    </div>
                </div>    
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('addsiteFileForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>

        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { uploadVerify , uploadSitesFile ,editSitesFile} from '@/service/site'
    import { UPLOAD_CODE } from "@/config/index";
    export default {
        name: "add",
        components: {
            PopoverRight,
        },
        props: {
            callback: Function,
            siteId: [Number, String],
        },
        data () {

            return {
                info:{
                    path:'',
                    remark:'',
                    name:'',
                },
                siteFileRules:{
                    remark: [
                        { required: true, message: '请填写备注', trigger: 'blur' },
                        { min: 1, max: 999, message: "长度在 1 到 999 个字符", trigger: "blur" },
                    ],
                    path:[{required: true, message: '请上传文件'}]
                },
                excelUrl:'',
                title:"上传文件",
                fileId:'',

            }
        },
        methods : {
            async open (row) {
                if(row && row.id){
                    this.title = "编辑备注"
                    this.fileId = row.id;
                    this.info ={...row};
                }else{
                    this.title = "上传文件"
                }
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            resetForm () { 
                this.excelUrl=''
                this.info={
                    path:'',
                    remark:'',
                    name:'',
                };
                this.title="上传文件";
                this.fileId='';
            },
            zipImg() {
                if (process.env.NODE_ENV === "development") {
                    this.excelUrl = process.env.VUE_APP_RESOURCE_URL + "/loushi/image/file.jpg";
                } else {
                    this.excelUrl =
                    window.serverConfig[window.siteMap[domain]].VUE_APP_RESOURCE_URL +
                    "/image/file.jpg";
                }
            },
            checkZtFile(e) {
                const file = e.target;
                const filePath = file.value;
                if (!filePath) return false;
                if (!/.(txt|html)$/.test(filePath)) {
                    this.$message({
                    type: "error",
                    message: "请选择.txt或.html格式",
                    });
                    return false;
                }
                const fileSize = file.files[0].size;
                this.info.name = file.files[0].name;
                if (fileSize / 1024 / 1024 > 1) {
                    this.$message({
                    type: "error",
                    message: "上传的文件不能大于1M",
                    });
                    return false;
                }
                this.uploadZhuanti(file.files[0]);
              
                
            },
            uploadZhuanti(file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("site_id", this.siteId);
                uploadVerify(UPLOAD_CODE.siteVerify,formData)
                    .then((res) => {
                        this.info.path = res.path;
                        this.zipImg();
                    })
                    .catch((err) => {
                    this.loading = false;
                    this.excelUrl = "";
                    const message = err.message;
                    this.$message({
                        message: message || "上传失败",
                        type: "error",
                        duration: 3 * 1000,
                    });
                });
            },
            clearUploadZt() {
                this.info.path = '';
                this.excelUrl = "";
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let query = this.info
                        query.site_id = this.siteId;
                        if(this.fileId){
                            editSitesFile(this.fileId,query).then((data) => {
                            this.$message({
                                message: '编辑成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hide()
                            this.callback && this.callback();
                            }).catch(err => {
                                this.$message({
                                    message: err.message || '编辑失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        }else{
                            uploadSitesFile(query).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hide()
                            this.callback && this.callback();
                            }).catch(err => {
                                this.$message({
                                    message: err.message || '添加失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        }
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped lang="less">
.upload-group-2 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  input{
      height: 152px !important;;
  }
}
.upload-group {
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
p.tip{
    color: #666;
    margin-left: 20px;
    line-height: 152px;
}
.huxing-input{
    display: -webkit-box;
    height: 152px;
}
.huxing-input {
  display: -webkit-box;
  height: 152px;
  .el-form-item {
    -webkit-box-flex: 1;
  }
  .labels {
    font-size: 13px;
    color: #666;
    padding: 0 8px;
    display: block;
  }
  .flex-all {
    -webkit-box-flex: 1;
  }
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
.result-area .result-tip{
    margin-bottom:10px;
}
.result-area .result-tip span{
    font-weight: bold;
}
</style>
